import React from 'react'

const PayRules = () => {
    return (
        <>PayRules mobile</>
    )
}

export { PayRules }